var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppStoreBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.143 0H3.857A3.858 3.858 0 0 0 0 3.857v28.286A3.858 3.858 0 0 0 3.857 36h28.286A3.858 3.858 0 0 0 36 32.143V3.857A3.858 3.858 0 0 0 32.143 0ZM10.205 28.326a1.605 1.605 0 1 1-2.78-1.607l1.15-1.985c1.293-.394 2.354-.089 3.181.916l-1.55 2.676Zm11.162-4.331H6.75a1.612 1.612 0 0 1-1.607-1.608c0-.883.723-1.607 1.607-1.607h4.098l5.256-9.096-1.648-2.845a1.61 1.61 0 0 1 .587-2.193 1.61 1.61 0 0 1 2.194.586l.715 1.238.715-1.238a1.605 1.605 0 1 1 2.78 1.607L14.553 20.78h4.99c1.623 0 2.531 1.905 1.824 3.215Zm7.883 0h-2.33l1.575 2.724a1.61 1.61 0 0 1-.587 2.194 1.61 1.61 0 0 1-2.194-.587c-2.643-4.572-4.62-8.012-5.946-10.294-1.342-2.33-.386-4.66.57-5.448 1.053 1.824 2.628 4.556 4.733 8.196h4.179a1.607 1.607 0 1 1 0 3.214Z",
    fill: "#25282B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppStoreBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/app_store__black.51a43c69ba159bc61a3f99fcf50d0abc.svg";